import { DataBean } from "../../DataBean";


export class HealthAttentionGateEntry extends DataBean {


    public async getHealthAttentionGateEntryCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAttentionGateEntryCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}